import { Alignment } from 'domain/constants/alignment';
import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';

const title = {
  default: css`
    text-align: left;
  `,
  centered: css`
    text-align: center;
  `,
};

const root = {
  default: css`
    display: flex;
    flex-direction: column;
    ${cssTheme.breakpoints.md} {
      flex-direction: row;
      justify-content: space-between;
    }
  `,
  centered: css`
    && {
      justify-content: center;
      align-items: center;
    }
  `,
};

const bold = css`
  font-weight: 600;
`;

const imagery = css`
  margin-top: ${cssTheme.gu2};
  ${cssTheme.breakpoints.md} {
    display: flex;
    margin-top: 0;
    padding-left: ${cssTheme.gu3};
  }
  ${cssTheme.breakpoints.lg} {
    padding-left: ${cssTheme.gu4};
  }
`;

const logo = {
  default: css`
    margin-bottom: ${cssTheme.gu2};
    height: ${cssTheme.gu4};
    ${cssTheme.breakpoints.md} {
      height: ${cssTheme.gu3};
      margin-left: auto;
      margin-top: 0;
      margin-right: ${cssTheme.gu2};
      margin-bottom: 0;
    }
    ${cssTheme.breakpoints.lg} {
      height: ${cssTheme.gu4};
    }
  `,
  centered: css`
    && {
      text-align: center;
    }
  `,
};

const stars = {
  default: css`
    height: ${cssTheme.gu3};
    ${cssTheme.breakpoints.lg} {
      height: ${cssTheme.gu4};
    }
  `,
  centered: css`
    && {
      text-align: center;
    }
  `,
};

const text = css`
  padding-right: ${cssTheme.gu3};
  ${cssTheme.breakpoints.lg} {
    padding-right: ${cssTheme.gu4};
  }
`;

interface InnerProps {
  alignment: Alignment;
}

export default ({ alignment }: InnerProps) => {
  return {
    root: cx(root.default, alignment === Alignment.CENTER && root.centered),
    bold,
    imagery,
    logo: cx(logo.default, alignment === Alignment.CENTER && logo.centered),
    stars: cx(stars.default, alignment === Alignment.CENTER && stars.centered),
    text,
    title: alignment === Alignment.CENTER ? title.centered : title.default,
  };
};
